import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
const t = (key, params) => app.translator.trans('ppk2-profile.lib.account_log.' + key, params);

/**
 * «Журнал изменений аккаунтов»: password / email changes from tab «Главная»
 * (GET /api/ppk2/account-changes; admins and the group «Техподдержка»). Read only.
 */
export default class AccountLog extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.q = '';
    this.rows = null;
    this.error = false;
    this.load();
  }
  load() {
    this.rows = null;
    this.error = false;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/ppk2/account-changes',
      params: this.q ? {
        q: this.q
      } : {}
    }).then(r => this.rows = r.data || [], () => this.error = true).finally(() => m.redraw());
  }
  view() {
    const date = iso => iso ? dayjs(iso).format('YYYY-MM-DD HH:mm') : '';
    return m("div", {
      className: "Ppk2AccountLog"
    }, m("form", {
      className: "Ppk2AccountLog-search",
      onsubmit: e => {
        e.preventDefault();
        this.load();
      }
    }, m("input", {
      className: "FormControl",
      type: "search",
      placeholder: t('log_search'),
      value: this.q,
      oninput: e => this.q = e.target.value
    }), m(Button, {
      className: "Button",
      type: "submit",
      icon: "fas fa-search"
    })), this.error ? m("p", {
      className: "helpText"
    }, "Error") : !this.rows ? m(LoadingIndicator, null) : !this.rows.length ? m("p", {
      className: "helpText"
    }, t('log_empty')) : m("div", {
      className: "Ppk2AccountLog-wrap"
    }, m("table", {
      className: "Ppk2AccountLog-table"
    }, m("thead", null, m("tr", null, ['c_date', 'c_user', 'c_type', 'c_reason', 'c_old', 'c_new', 'c_ip', 'c_status'].map(k => m("th", null, t(k))))), m("tbody", null, this.rows.map(r => m("tr", {
      className: 'Ppk2AccountLog-row--' + r.status
    }, m("td", null, date(r.createdAt)), m("td", null, r.username || '#' + (r.userId || '—')), m("td", null, t('t_' + r.type)), m("td", null, r.reason ? t('r_' + r.reason) : '', r.note ? m("div", {
      className: "Ppk2AccountLog-note"
    }, r.note) : null), m("td", null, r.oldEmail || ''), m("td", null, r.newEmail || ''), m("td", null, r.ip || ''), m("td", null, t('s_' + r.status), r.revertedAt ? m("div", {
      className: "Ppk2AccountLog-note"
    }, date(r.revertedAt) + (r.revertedIp ? ' · ' + r.revertedIp : '')) : null)))))));
  }
}
flarum.reg.add('ppk2-profile', 'common/AccountLog', AccountLog);